export const environment = {
  ClientAdminUrl: "https://admin-stage.savepesquisas.com.br",
  ContactsMailAddress: "save@savepesquisas.com.br",
  SendMailFunctionUrl:
    "https://func-save-stage.azurewebsites.net/api/SendMail?code=hAqD5dFXI5KYiw1HWkftiN9RZ1FpWcpX-8eh9gHfq9PaAzFuX6x9vA==",
};
